export default "__VITE_ASSET__HMJgN_jd__"